import {GenericEntity} from './generic-entity.model';


export class Brand extends GenericEntity {
    id: number;
    brandCode: string;
    brandId: number;
    modelCode: string;
    modelId: number;

    constructor(props = {}) {
        super(props);
        Object.assign(this, props);
    }
}

export class BrandSimple {
    id: number;
    code: string;
}
